import _ from 'lodash';
import getConfig from 'next/config';
import PropTypes from 'prop-types';

import { cmsService } from '../services/homii-services';

import { Layout, MetaData, Footer } from '../components/shared';

import BlogPageHeader from '../components/blog-components/blog-page-header.component';
import BlogPageFeatured from '../components/blog-components/blog-page-featured.component';
import BlogPagePosts from '../components/blog-components/blog-page-posts.component';
import BlogPagePagination from '../components/blog-components/blog-page-pagination.component';
import useResponsive from '../../utils/responsive';


const Blog = (props) => {

    const { blogData, blogPage, baseUrlApp, blogTags } = props;    
    const { next_page, previous_page, count } = blogData.meta;
    const { isMobile } = useResponsive();

    const heroTitle = _.get(blogPage, 'acf.hero_title');
    const heroSubHeading = _.get(blogPage, 'acf.hero_sub_heading');
    const seoTitle = _.get(blogPage, 'acf.seo_title');
    const seoDesc = _.get(blogPage, 'acf.seo_meta_description');
    const blogs = _.get(blogData, 'blogs');

    return (
        <Layout>
            
            <MetaData title={seoTitle} desc={seoDesc} canonical={`${baseUrlApp}/blog`} />
            
            <BlogPageHeader title={heroTitle} subheading={heroSubHeading} />
            
            <BlogPageFeatured data={blogs} />
            
            <BlogPagePosts data={blogs} blogTags={blogTags} />
            
            {!isMobile && <BlogPagePagination nextPage={next_page} prevPage={previous_page} count={count} />}

            <Footer  />

        </Layout>
    );
};

export default Blog;

export const getServerSideProps = async ({ query }) => {

    const page = parseInt(query.page || 1);

    let filter = _.get(query, 'filter');

    if (filter === 'all') {
        filter = null;
    }

    const { publicRuntimeConfig } = getConfig();

    const blogData = await cmsService.ListWordPressBlogPosts(        
        publicRuntimeConfig.DEFAULT_BLOG_PAGINATION_PAGE_SIZE,
        page,
        filter
    );

    const blogPage = await cmsService.RetrieveWordPressPage('blog');

    const blogTags = await cmsService.ListWordPressBlogTags();

    return {
        props: {
            blogData, blogPage, blogTags
        }
    }

};

Blog.propTypes = {
    blogData: PropTypes.object,
    baseUrlApp: PropTypes.string,
    blogPage: PropTypes.object,
    blogTags: PropTypes.array,
};
